<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.title"
        placeholder="请输入标题"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.devices"
        placeholder="请输入标签"
      ></el-input>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.is_up"
        placeholder="请选择是否上架"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 10px">
      <el-button
        type="primary"
        @click="addMenu(0)"
        style="margin-bottom: 5px"
        v-if="roles.includes('/place/farm_add')"
        >添加</el-button
      >
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="类型" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? '共享空间' : "智慧农场会场" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="标题" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图" width="150" align="center">
        <template slot-scope="scope">
          <el-image
            v-for="(img, ind) in scope.row.picurl.split(',')"
            :key="ind"
            style="width: 120px; height: 40px; margin: 0 5px 5px 0"
            :src="imageOss + img"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.picurl.split(','))"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="标签" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.devices }}</span>
        </template>
      </el-table-column>
      <el-table-column label="租金单价">
        <template slot-scope="scope">
          <span>{{ scope.row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column label="租金单位">
        <template slot-scope="scope">
          {{ scope.row.unit }}
        </template>
      </el-table-column>
      <el-table-column label="最小容纳人数" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.min_num }}</span>
        </template>
      </el-table-column>
      <el-table-column label="最大容纳人数">
        <template slot-scope="scope">
          {{ scope.row.max_num }}
        </template>
      </el-table-column>
      <el-table-column label="排序">
        <template slot-scope="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>
      <el-table-column label="详细地址">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.address }}</div>
        </template>
      </el-table-column>
      <el-table-column label="上下架状态" min-width="100" align="center">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
          <el-tag
            :type="scope.row.is_up == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.is_up == 1 ? "上架" : "下架" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/place/farm_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/place/farm_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/place/farm_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="类型" prop="type">
          <el-radio-group v-model="ruleForm.type" :disabled="cztype == 'see'">
            <el-radio :label="1">共享空间</el-radio>
            <el-radio :label="2">智慧农场会场</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="标题" prop="title">
          <el-input
            :disabled="cztype == 'see'"
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="设备" prop="devices">
          <el-input
            class="w4"
            :disabled="cztype == 'see'"
            v-model="ruleForm.devices"
            placeholder="请输入设备"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="标签" prop="desList">
          <span slot="label"><span style="color: #f00">*</span> 标签</span>
          <el-button
            v-if="cztype != 'see'"
            size="mini"
            type="primary"
            @click="addDes()"
            >添加标签</el-button
          >
          <div>
            <div class="tabBox" v-for="(item, index) in desList" :key="index">
              <el-input
                style="width: 200px"
                :disabled="cztype == 'see'"
                v-model="item.val"
                placeholder="请输入标签"
              ></el-input>
              <i
                v-if="cztype != 'see' && index != 0"
                class="el-icon-delete"
                style="margin-left: 20px"
                @click="delDes(index)"
              ></i>
            </div>
          </div>
          <span style="color: #f00" v-show="tabShow">请输入标签</span>
        </el-form-item>
        <el-form-item label="封面图" prop="picurl">
          <el-upload
            name="file[]"
            :limit="1"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="picurlHandleRemovePic"
            :on-success="picurlHandleAvatarSuccess"
            :disabled="cztype == 'see'"
            :class="fileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="轮播图" prop="thumb">
          <el-upload
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            name="file[]"
            :data="{ type: 'image' }"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="thumbFileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :disabled="cztype == 'see'"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>




<!-- 
        <el-form-item label="轮播图" prop="thumb">
          <el-upload
          multiple
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="thumbFileList"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          >
        </el-form-item> -->

        <!-- <el-form-item label="租金时长单位" prop="unit">
          <el-input
            class="w4"
            :disabled="cztype == 'see'"
            v-model="ruleForm.unit"
            placeholder="租金时长单位(例：天、小时...)"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="租金单价" prop="money">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            v-model="ruleForm.money"
            placeholder="请输入租金单价"
            ><template slot="append">元/h</template></el-input
          >
        </el-form-item>
        <el-form-item label="最小容纳人数" prop="min_num">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            v-model="ruleForm.min_num"
            placeholder="请输入租最小容纳人数"
            ><template slot="append">人</template></el-input
          >
        </el-form-item>
        <el-form-item label="最大容纳人数" prop="max_num">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            v-model="ruleForm.max_num"
            placeholder="请输入最大容纳人数"
            ><template slot="append">人</template></el-input
          >
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            type="textarea"
            :rows="2"
            class="w4"
            :disabled="cztype == 'see'"
            v-model="ruleForm.address"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            :disabled="cztype == 'see'"
            v-model="ruleForm.sort"
            placeholder="请输入排序"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细介绍" prop="content">
          <Editor
            :disabled="cztype == 'see'"
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.content"
          />
        </el-form-item>
        <el-form-item label="时间段" prop="sort">
          <el-button
            v-if="cztype != 'see'"
            size="mini"
            type="primary"
            @click="addTime()"
            >添加时间段</el-button
          >
          <div
            style="margin-top: 10px"
            v-for="(item, index) in time_bucket"
            :key="index"
          >
            <el-time-select
              :disabled="cztype == 'see'"
              placeholder="起始时间"
              v-model="item.startTime"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '24:00',
              }"
            >
            </el-time-select>
            至
            <el-time-select
              :disabled="cztype == 'see'"
              placeholder="结束时间"
              v-model="item.endTime"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '24:00',
                minTime: item.startTime,
              }"
            >
            </el-time-select>
            <i
              v-if="cztype != 'see'"
              class="el-icon-delete"
              style="margin-left: 20px"
              @click="delTime(index)"
            ></i>
          </div>
        </el-form-item>
        <el-form-item label="上下架状态" prop="content">
          <el-radio-group v-model="ruleForm.is_up" :disabled="cztype == 'see'">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="意向用户列表" :visible.sync="dialogVisible" width="60%">
      <el-table
        v-loading="userLoading"
        :data="registerUserList"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        row-key="id"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{
              (registerUser.page - 1) * registerUser.page_size +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column label="房屋名称">
          <template slot-scope="scope">
            <span v-if="scope.row.house">
              {{ scope.row.house.title }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-pagination
          :page-size="registerUser.page_size"
          @current-change="registerPageChange"
          layout="prev, pager, next"
          :current-page="registerUser.page"
          :total="registerUser.total"
        >
        </el-pagination>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, delImage } from "@/api/index";
import {
  venueAdd,
  venueEdit,
  venueList,
  venueDel,
  venueInfo,
} from "@/api/smartFarm";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        devices: "",
        title: "",
        is_up: "",
      },
      typeList: [],
      total: 0,
      ruleForm: {},
      fileList: [],
      thumbFileList: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        thumb: [{ required: true, message: "请选择轮播图" }],
        picurl: [{ required: true, message: "请选择封面图片" }],
        devices: [{ required: true, message: "请输入设备" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入详细介绍", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        money: [{ required: true, message: "请输入租金单价", trigger: "blur" }],
        unit: [
          { required: true, message: "请输入租金时长单位", trigger: "blur" },
        ],
        min_num: [
          { required: true, message: "请输入最小容纳人数", trigger: "blur" },
        ],
        max_num: [
          { required: true, message: "请输入最大容纳人数", trigger: "blur" },
        ],
        contact_phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      clearPics: [],
      registerUser: {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
      },
      registerUserList: [],
      formTypeList: [],
      percentage: 0,
      percentageShow: true,
      clearThumb: [],
      time_bucket: [
        {
          startTime: "",
          endTime: "",
        },
      ],
      desList: [
        {
          val: "",
        },
      ],
      tabShow: false,
      startTime: "",
      endTime: "",
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.thumb = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },




    // 比较时间段是否重叠
    Fn() {
      var that = this;
      for (let k in this.time_bucket) {
        if (!that.judege(k)) {
          return false;
        }
      }
      return true;
    },
    judege(idx) {
      for (let k in this.time_bucket) {
        if (idx !== k) {
          if (
            this.time_bucket[k].startTime <= this.time_bucket[idx].startTime &&
            this.time_bucket[k].endTime > this.time_bucket[idx].startTime
          ) {
            return false;
          }
          if (
            this.time_bucket[k].startTime < this.time_bucket[idx].endTime &&
            this.time_bucket[k].endTime >= this.time_bucket[idx].endTime
          ) {
            return false;
          }
        }
      }
      return true;
    },
    // // 判断时间是否交叉重复
    // timeChange(val, index) {
    //   let start = []; //开始时间
    //   let over = []; //结束时间
    //   for (let i = 0; i < this.time_bucket.length; i++) {
    //     start.push(this.time_bucket[i].time[0]);
    //     over.push(this.time_bucket[i].time[1]);
    //   }
    //   start.sort();
    //   over.sort();
    //   for (let i = 1; i < start.length; i++) {
    //     if (start[i] <= over[i - 1]) {
    //       this.$message({
    //         type: "warning",
    //         message: "所选时间段不能重合",
    //       });
    //       this.time_bucket[index].time = "";
    //       return;
    //     }
    //   }
    // },

    // 添加标签
    addDes() {
      this.desList.push({
        val: "",
      });
    },
    delDes(index) {
      this.desList.splice(index, 1);
    },
    // 添加时间段
    addTime() {
      this.time_bucket.push({
        time: "",
      });
    },
    delTime(index) {
      this.time_bucket.splice(index, 1);
    },
    delVideo() {
      this.clearVideos.push(this.ruleForm.video);
      this.ruleForm.video = "";
    },
    videoProgross(e) {
      this.percentage = parseInt(e.percent);
    },
    handleVideoSuccess(res, file, fileList) {
      this.percentageShow = false;
      if (res.code === 200) {
        this.ruleForm.video = res.data.url;
      } else {
        this.$message.error("上传失败，" + res.msg);
      }
    },
    videoErr() {
      this.$message.error("上传失败");
    },
    picurlHandleRemovePic(file, fileList) {
      this.fileList = [];
      this.ruleForm.picurl = "";
      // if (file.response.data.url) {
      //   this.clearPics.push(file.response.data.url);
      // }
      // var list = [];
      // list = fileList.map((item) => {
      //   return item.response.data.url;
      // });
      // this.ruleForm.picurl = list.join(",");
    },
    // handleRemovePic(file, fileList) {
    //   this.thumbFileList = fileList;
    //   var list = [];
    //   list = fileList.map((item) => {
    //     return item.response.data.url;
    //   });
    //   this.ruleForm.thumb = list.join(",");
    // },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.thumb = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
      if (this.clearThumb.length) {
        delImage({ file: this.clearThumb.join(",") }).then((ress) => {});
      }
    },
    picurlHandleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.picurl = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // handleAvatarSuccess(res, file, fileList) {
    //   console.log(fileList)
    //   console.log(res)
    //   this.thumbFileList = []
    //   if (res.code === 200) {
    //     console.log(res)
    //     var list = [];
    //     list = fileList.map((item) => {
    //       console.log(item)
    //       return item.response.data.url;
    //     });
    //     this.thumbFileList.push({ url: this.imageOss + res.data.url });
    //     this.ruleForm.thumb = list.join(",");
    //   } else {
    //     this.$message({
    //       message: res.msg,
    //       type: "error",
    //     });
    //     var list = [];
    //     fileList.map((item) => {
    //       if (item.response.code == 200) {
    //         list.push({
    //           name: +new Date(),
    //           url: imageOss + item.response.data.url,
    //           response: {
    //             data: {
    //               url: item.response.data.url,
    //             },
    //           },
    //         });
    //       }
    //     });
    //     this.fileList = list;
    //   }
    //   // this.ruleForm.icon = URL.createObjectURL(file.raw)
    // },
    reset() {
      this.screen = {
        park_id: "",
        title: "",
        page: 1,
        page_size: 15,
        is_up: "",
        devices: "",
        type: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      var desList = [];
      let show = 0;
      that.desList.forEach((item) => {
        if (item.val) {
          desList.push(item.val);
        } else {
          show++;
        }
      });
      if (show != 0) {
        that.tabShow = true;
        return;
      } else {
        that.tabShow = false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.Fn()) {
            this.$message({
              type: "warning",
              message: "所选时间段不能重合",
            });
            return;
          }
          let timeBucket = [];
          that.time_bucket.forEach((item) => {
            timeBucket.push(item.startTime + "-" + item.endTime);
          });
          that.ruleForm.time_bucket = JSON.stringify(timeBucket);
          this.ruleForm.devices = desList.join(",");
          this.$confirm("确认提交？")
            .then(() => {
              venueEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.clearPics = [];
      this.fileList = [];
      this.thumbFileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleInfo(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.clearPics = [];
      this.fileList = [];
      this.thumbFileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    registerPageChange(current) {
      this.registerUser.page = current;
      this.getRegisteredList();
    },
    getRegisterUser(house_id) {
      this.userLoading = true;
      this.registerUser = {
        house_id,
        page: 1,
        page_size: 15,
        total: 0,
      };
      this.getRegisteredList();
    },
    getRegisteredList() {
      intention_user(this.registerUser).then((res) => {
        this.userLoading = false;
        this.dialogVisible = true;
        this.registerUserList = res.data.lists.data;
        this.registerUser.page = res.data.lists.current_page;
        this.registerUser.total = res.data.lists.total;
      });
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      that.time_bucket = [];
      venueInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_id: Number(res.data.info.park_id),
          title: res.data.info.title,
          devices: res.data.info.devices,
          sort: res.data.info.sort,
          picurl: res.data.info.picurl,
          thumb: res.data.info.thumb.join(","),
          money: res.data.info.money,
          unit: res.data.info.unit,
          min_num: res.data.info.min_num,
          max_num: res.data.info.max_num,
          address: res.data.info.address,
          content: res.data.info.content,
          is_up: res.data.info.is_up,
          type: res.data.info.type,
        };
        that.desList = [];
        if (res.data.info.devices) {
          let deslist = res.data.info.devices.split(",");
          deslist.forEach((item) => {
            that.desList.push({
              val: item,
            });
          });
        }
        if (res.data.info.place_time_bucket) {
          res.data.info.place_time_bucket.forEach((item, index) => {
            // let date = {
            //   startTime: item.show_time.split("-")[0],
            //   endTime:item.show_time.split("-")[1]
            // };
            that.time_bucket.push({
              startTime: item.show_time.split("-")[0],
              endTime: item.show_time.split("-")[1],
            });
            // this.$set(that.time_bucket,date);
          });
        }

        if (res.data.info.picurl) {
          var list = res.data.info.picurl.split(",");
          this.fileList = list.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
        if (res.data.info.thumb) {
          this.thumbFileList = res.data.info.thumb.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          venueDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      // return;
      var that = this;
      var desList = [];
      let show = 0;
      that.desList.forEach((item) => {
        if (item.val) {
          desList.push(item.val);
        } else {
          show++;
        }
      });
      if (show != 0) {
        that.tabShow = true;
      }
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.Fn()) {
            this.$message({
              type: "warning",
              message: "所选时间段不能重合",
            });
            return;
          }
          this.$confirm("确认提交？")
            .then(() => {
              let timeBucket = [];
              that.time_bucket.forEach((item) => {
                timeBucket.push(item.startTime + "-" + item.endTime);
              });
              that.ruleForm.time_bucket = JSON.stringify(timeBucket);
              this.ruleForm.devices = desList.join(",");
              venueAdd(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        title: "",
        devices: "",
        sort: 0,
        picurl: "",
        thumb: "",
        money: "",
        unit: "",
        min_num: "",
        max_num: "",
        address: "",
        content: "",
        is_up: 1,
        type: 1,
      };
      this.tabShow = false
      this.clearPics = [];
      this.fileList = [];
      this.thumbFileList = [];
      this.time_bucket = [
        {
          startTime: "",
          endTime: "",
        },
      ];
      this.desList = [
        {
          val: "",
        },
      ];
      this.clearThumb = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      venueList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.tabBox {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
